import "./styles/_main.scss";
host.plugins.register({
    // #region Vars
    name: "288a.ecommerce.core",
    // #endregion
    // #region Register
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
        host.actions.registerAll(require.context('./actions', true, /(?<!views)\.ts$/));
    },
    // #endregion
});
